import Footer from "../../../components/footer";
import HomeHeroSection from "../components/HomeHeroSection";
import HomeTopCardsSection from "../components/HomeTopCardsSection";
import HomeMiddleCardsSection from "../components/HomeMiddleCardsSection";
import HomeAguadaSection from "../components/HomeAguadaSection";
import HomeRecordsSection from "../components/HomeRecordsSection";
import { useNavigate } from "react-router-dom";
import useHomeData from "../hooks/useHomeData";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import escudo from '../../../images/escudo.png';
import hero from '../../../images/hero.png';


function Home() {
    const navigate = useNavigate();
    const [topRowRef, topRowVisible] = useRevealOnScroll();
    const [aguadaRowRef, aguadaRowVisible] = useRevealOnScroll();
    const [recordsRowRef, recordsRowVisible] = useRevealOnScroll();
    const [footerRef, footerVisible] = useRevealOnScroll();
    const {
        cantidadPartidosTotal,
        cantidadPartidosGanados,
        cantidadPartidosPerdidos,
        ultimoPartido,
        unDiaComoHoy,
        enAguada,
        enAguadaGanados,
        enAguadaPerdidos,
        partidosJugador,
        ptsJugador,
        rtJugador,
        astJugador,
        minPromJugador,
        ptsPromJugador,
        rtPromJugador,
        astPromJugador,
        listadoJugadores,
        listadoTecnicos,
        isLoading,
        getPercentage,
    } = useHomeData();

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a]">
            <PageBackgroundPattern />
            <div className="relative z-10">
                <HomeHeroSection
                hero={hero}
                escudo={escudo}
                isLoading={isLoading}
                cantidadPartidosTotal={cantidadPartidosTotal}
                cantidadPartidosGanados={cantidadPartidosGanados}
                cantidadPartidosPerdidos={cantidadPartidosPerdidos}
                getPercentage={getPercentage}
            />

                <div className="overflow-hidden py-12 sm:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div ref={topRowRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        <HomeTopCardsSection
                            listadoJugadores={listadoJugadores}
                            listadoTecnicos={listadoTecnicos}
                            navigate={navigate}
                            ultimoPartido={ultimoPartido}
                            revealed={isLoading && topRowVisible}
                        />

                        <HomeMiddleCardsSection
                            unDiaComoHoy={unDiaComoHoy}
                            revealed={isLoading && topRowVisible}
                        />
                    </div>

                    <div
                        ref={aguadaRowRef}
                        className="transition-all duration-700 ease-out"
                        style={{ opacity: isLoading && aguadaRowVisible ? 1 : 0, transform: isLoading && aguadaRowVisible ? 'translateX(0)' : 'translateX(-2rem)' }}
                    >
                        <HomeAguadaSection
                            enAguada={enAguada}
                            enAguadaGanados={enAguadaGanados}
                            enAguadaPerdidos={enAguadaPerdidos}
                            getPercentage={getPercentage}
                            isLoading={isLoading}
                        />
                    </div>
                </div>

                <div
                    ref={recordsRowRef}
                    className="transition-all duration-700 ease-out"
                    style={{ opacity: isLoading && recordsRowVisible ? 1 : 0, transform: isLoading && recordsRowVisible ? 'translateX(0)' : 'translateX(2rem)' }}
                >
                    <HomeRecordsSection
                        partidosJugador={partidosJugador}
                        ptsJugador={ptsJugador}
                        rtJugador={rtJugador}
                        astJugador={astJugador}
                        minPromJugador={minPromJugador}
                        ptsPromJugador={ptsPromJugador}
                        rtPromJugador={rtPromJugador}
                        astPromJugador={astPromJugador}
                    />
                </div>

                <div ref={footerRef} className="transition-opacity duration-700 ease-out" style={{ opacity: isLoading && footerVisible ? 1 : 0 }}>
                    <Footer></Footer>
                </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
